<template>
    <div class="a-preview-survey">
        <div class="a-preview-survey__inner">
            <div class="a-preview-survey__header">
                <div class="a-preview-survey__navigation">
                    <p class="a-preview-survey__title">ボーナスアンケート</p>
                </div>
            </div>

            <div class="a-preview-survey__heading">
                <img :src="require('@/assets/images/img-bonus-survey.png')" width="76" height="88" alt="">
                <p class="a-preview-survey__name">{{title}}</p>
                <img :src="require('@/assets/images/img-standard-cb.png')" width="54" height="54" alt="">
            </div>
            <div class="a-preview-survey__description" v-html="$attrs.innerHTML"></div>
            <div class="a-preview-survey__meta">
                <p class="a-preview-survey__text">
                    <span>
                        <svg width="22" height="22" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                            <path d="M17.4286 17.7143L14.5357 17.7143L14.5357 14.8214L17.4286 14.8214L17.4286 17.7143ZM13.8929 17.7143L10.6786 17.7143L10.6786 14.8214L13.8929 14.8214L13.8929 17.7143ZM17.4286 14.1786L14.5357 14.1786L14.5357 10.9643L17.4286 10.9643L17.4286 14.1786ZM13.8929 14.1786L10.6786 14.1786L10.6786 10.9643L13.8929 10.9643L13.8929 14.1786ZM17.4286 10.3214L14.5357 10.3214L14.5357 7.42857L17.4286 7.42857L17.4286 10.3214ZM10.0357 17.7143L6.82144 17.7143L6.82144 14.8214L10.0357 14.8214L10.0357 17.7143ZM13.8929 10.3214L10.6786 10.3214L10.6786 7.42857L13.8929 7.42857L13.8929 10.3214ZM6.17858 17.7143L3.28572 17.7143L3.28572 14.8214L6.17858 14.8214L6.17858 17.7143ZM10.0357 14.1786L6.82144 14.1786L6.82144 10.9643L10.0357 10.9643L10.0357 14.1786ZM13.5714 5.5L13.5714 2.60714C13.5714 2.52009 13.6032 2.44475 13.6669 2.38114C13.7305 2.31752 13.8058 2.28571 13.8929 2.28571L14.5357 2.28571C14.6228 2.28571 14.6981 2.31752 14.7617 2.38114C14.8253 2.44475 14.8572 2.52009 14.8572 2.60714L14.8572 5.5C14.8572 5.58705 14.8253 5.66239 14.7617 5.726C14.6981 5.78962 14.6228 5.82143 14.5357 5.82143L13.8929 5.82143C13.8058 5.82143 13.7305 5.78962 13.6669 5.726C13.6032 5.66239 13.5714 5.58705 13.5714 5.5ZM6.17858 14.1786L3.28572 14.1786L3.28572 10.9643L6.17858 10.9643L6.17858 14.1786ZM10.0357 10.3214L6.82144 10.3214L6.82144 7.42857L10.0357 7.42857L10.0357 10.3214ZM6.17858 10.3214L3.28572 10.3214L3.28572 7.42857L6.17858 7.42857L6.17858 10.3214ZM5.85715 5.5L5.85715 2.60714C5.85715 2.52009 5.88896 2.44475 5.95258 2.38114C6.01619 2.31752 6.09153 2.28571 6.17858 2.28571L6.82144 2.28571C6.90849 2.28571 6.98383 2.31752 7.04744 2.38114C7.11106 2.44475 7.14287 2.52009 7.14287 2.60714L7.14287 5.5C7.14287 5.58705 7.11106 5.66239 7.04744 5.726C6.98383 5.78962 6.90849 5.82143 6.82144 5.82143L6.17858 5.82143C6.09153 5.82143 6.01619 5.78962 5.95258 5.726C5.88896 5.66239 5.85715 5.58705 5.85715 5.5ZM2.00001 4.85714L2.00001 17.7143C2.00001 18.0625 2.12724 18.3638 2.38171 18.6183C2.63617 18.8728 2.93751 19 3.28572 19L17.4286 19C17.7768 19 18.0781 18.8728 18.3326 18.6183C18.5871 18.3638 18.7143 18.0625 18.7143 17.7143L18.7143 4.85714C18.7143 4.50893 18.5871 4.20759 18.3326 3.95312C18.0781 3.69866 17.7768 3.57143 17.4286 3.57143L16.1429 3.57143L16.1429 2.60714C16.1429 2.16518 15.9855 1.78683 15.6708 1.4721C15.356 1.15737 14.9777 1 14.5357 1L13.8929 1C13.4509 1 13.0726 1.15737 12.7578 1.4721C12.4431 1.78683 12.2857 2.16518 12.2857 2.60714L12.2857 3.57143L8.42858 3.57143L8.42858 2.60714C8.42858 2.16518 8.27122 1.78683 7.95648 1.4721C7.64175 1.15737 7.2634 0.999999 6.82144 0.999999L6.17858 0.999999C5.73662 0.999999 5.35827 1.15737 5.04354 1.4721C4.7288 1.78683 4.57144 2.16518 4.57144 2.60714L4.57144 3.57143L3.28572 3.57143C2.93751 3.57143 2.63617 3.69866 2.38171 3.95312C2.12724 4.20759 2.00001 4.50893 2.00001 4.85714Z" />
                        </svg>
                    </span>
                    <span>ボーナス実施期間</span>
                    <span v-if="(endDate instanceof Date)">{{endDate.toLocaleDateString().replace(/(\d{4})\/(\d{1,2})\/(\d{1,2})/, '$1年$2月$3日')}}まで</span>
                </p>
                <p class="a-preview-survey__text">
                    <span><img :src="require('@/assets/images/img-promotion-cap.png')" width="22" height="22" alt=""></span>
                    <span>先着</span>
                    <span v-if="capacity">{{capacity}}名</span>
                </p>
            </div>

            <button type="button" class="a-preview-survey__submit" @click.prevent>アンケートに答える</button>
        </div>
    </div>
</template>

<script>
// import composition-api.
import {defineComponent} from 'vue';

export default defineComponent({
    inheritAttrs: false,
    props: {
        title: {
            type: String,
            default: ''
        },
        endDate: {
            type: Object,
            default: null
        },
        capacity: {
            type: Number,
            default: 0
        }
    }
});
</script>

<style lang="scss" scoped>
.a-preview-survey {
    position: relative;
    width: 390px;
    aspect-ratio: 390 / 790;
    transform: scale((280 / 390));
    padding: 48px 20px 16px 20px;
    min-height: 790px;
    color: #000;

    &::before {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        display: block;
        content: "";
        background-image: url(/img/bg-iphone-mockup.png);
        background-size: cover;
        pointer-events: none;
        z-index: 2;
    }

    @at-root {
        .a-preview-survey__inner {
            position: relative;
            background: var.$color-utils-background;
            overflow: hidden scroll;
            height: calc(100% - 50px);
            border-radius: 8px;
            margin-top: 50px;
        }

        .a-preview-survey__header {
            position: fixed;
            top: 48px;
            left: 22px;
            right: 18px;
            z-index: 1;
        }

        .a-preview-survey__navigation {
            display: flex;
            align-items: center;
            background: var.$color-utils-background;
            padding: 0 16px;
            height: 50px;
            box-shadow: 0 1px 4px rgba(#000, .1);
            z-index: 1;
        }

        .a-preview-survey__title {
            position: relative;
            font-size: 1.6rem;
            line-height: 1;
            letter-spacing: 0;
            padding: 0 44px;
            width: 100%;
            text-align: center;
            font-weight: bold;

            &::before {
                display: block;
                position: absolute;
                top: 0;
                bottom: 0;
                left: 12px;
                content: "";
                width: 12px;
                height: 12px;
                margin: auto;
                border-left: solid 1px #000;
                border-bottom: solid 1px #000;
                transform: rotate(45deg);
            }
        }

        .a-preview-survey__submit {
            position: sticky;
            bottom: 2px;
            left: 0;
            right: 0;
            width: 100%;
            min-height: 50px;
            display: flex;
            justify-content: center;
            align-items: center;
            background: #23AC38;
            color: var.$color-text-white;

            &[disabled] {
                cursor: default;
                background: #808080;
            }
        }

        .a-preview-survey__heading {
            display: flex;
            align-items: center;
            padding: 30px 20px 30px 32px;
        }

        .a-preview-survey__name {
            font-size: 1.3rem;
            line-height: (18 / 13);
            letter-spacing: -.03em;
            margin: auto 6px auto 26px;
            width: 100%;
        }

        .a-preview-survey__description {
            font-size: 1.3rem;
            line-height: (18 / 13);
            letter-spacing: -.03em;
            padding: 26px 20px;
            border-top: solid 1px rgba(#6FD364, .25);
            border-bottom: solid 1px rgba(#6FD364, .25);

            ::v-deep(h1), ::v-deep(h2), ::v-deep(h3), ::v-deep(h4), ::v-deep(h5), ::v-deep(h6) {
                margin-top: 16px;

                + p {
                    margin-top: 16px;
                }
            }

            ::v-deep(a) {
                color: inherit;
                text-decoration: underline;
            }

            ::v-deep(img) {
                width: 100%;
            }

            ::v-deep(ul) {
                list-style: disc;
                padding-left: 14px;

                &:not(:first-child) {
                    margin-top: 16px;
                }
            }

            ::v-deep(ol) {
                list-style: decimal;
                padding-left: 14px;

                &:not(:first-child) {
                    margin-top: 16px;
                }
            }
        }

        .a-preview-survey__meta {
            padding: 14px 10px;
        }

        .a-preview-survey__text {
            display: flex;
            align-items: center;
            font-size: 1.3rem;
            line-height: (18 / 13);
            letter-spacing: -.03em;

            > span {
                width: 82px;
            }

            &:not(:first-child) {
                margin-top: 18px;
            }

            > :first-child {
                color: #23AC38;
                margin: 0 20px;
                width: auto;
            }

            > :nth-child(3) {
                width: auto;
                margin-left: 8px;
            }
        }
    }
}

@media screen and (-webkit-min-device-pixel-ratio: 0) {
    _::-webkit-full-page-media, _:future, .a-preview-survey__inner {
        height: 673px;
    }

    _::-webkit-full-page-media, _:future, .a-preview-survey__submit {
        bottom: -188px;
        transform: translateY(2px);
    }
}
</style>
